import { useEffect, useState } from 'react';
import I18n from 'I18n';
export const useCollabGenerateTriggersPrompt = ({
  isCopilotReady,
  objectTypeId,
  sendActionFromAppToCopilot
}) => {
  const [hasPromptedCopilot, setHasPromptedCopilot] = useState(false);
  useEffect(() => {
    if (hasPromptedCopilot || !isCopilotReady) {
      return;
    }
    setHasPromptedCopilot(true);
    sendActionFromAppToCopilot({
      title: I18n.text('automation.collabGenActionsFlow.generateActionsPrompt.askForMoreInfo.title'),
      promptData: {
        commandName: 'ask_for_more_options_v1',
        // The path specifies the path in the data object to update with the response from the user in copilot.
        path: ['data', 'userInput'],
        // What to ask the customer when the panel opens.
        promptThread: I18n.text('automation.collabGenTriggersFlow.generateTriggersPrompt.askForMoreInfo.prompt')
      },
      data: {
        intent: 'generate_automation_triggers',
        objectTypeId
        // NOTE: userInput: is filled in by the promptData path when the customer responds to the prompt.
      }
    });
  }, [isCopilotReady, sendActionFromAppToCopilot, objectTypeId, hasPromptedCopilot]);
};
export default useCollabGenerateTriggersPrompt;